function ProductFeatures({

    typeId,
    features,
    featureValues,
    handleFeatureChange

}) {

    return (

        <div className="card shadow-sm border-0">

            <div className="card-header bg-primary text-white">

                <h5 className="mb-0">

                    Product Features

                </h5>

            </div>

            <div className="card-body p-4">

                {

                    !typeId ?

                        (

                            <div className="text-center text-muted py-5">

                                <h6>

                                    Select Product Type

                                </h6>

                                <small>

                                    Features will appear here

                                </small>

                            </div>

                        )

                        :

                        (

                            <div className="row g-3">

                                {

                                    features.map(feature => (

                                        <div
                                            className="col-md-6 mb-3"
                                            key={feature.id}
                                        >
                                            <div className="feature-card">

                                                <label className="form-label fw-semibold">

                                                    {feature.name}

                                                </label>

                                                {

                                                    feature.options &&
                                                        feature.options.length > 0 ?

                                                        (

                                                            <select

                                                                className="form-select"

                                                                value={featureValues[feature.id] || ""}

                                                                onChange={(e) =>

                                                                    handleFeatureChange(

                                                                        feature.id,

                                                                        e.target.value

                                                                    )

                                                                }

                                                            >

                                                                <option value="">

                                                                    Select {feature.name}

                                                                </option>

                                                                {

                                                                    feature.options.map(option => (

                                                                        <option
                                                                            key={option.id}
                                                                            value={option.optionValue}
                                                                        >

                                                                            {option.optionValue}

                                                                        </option>

                                                                    ))

                                                                }

                                                            </select>

                                                        )

                                                        :

                                                        (

                                                            <input

                                                                type="text"

                                                                className="form-control"

                                                                placeholder={`Enter ${feature.name}`}

                                                                value={featureValues[feature.id] || ""}

                                                                onChange={(e) =>

                                                                    handleFeatureChange(

                                                                        feature.id,

                                                                        e.target.value

                                                                    )

                                                                }

                                                            />

                                                        )

                                                }
                                            </div>

                                        </div>

                                    ))

                                }

                            </div>

                        )

                }

            </div>

        </div>

    );

}

export default ProductFeatures;